import { Sidebar } from 'components/Sidebar/Sidebar';
import { InvoiceVerificationDTO, MessageV2DTO, PartnerDTO, SenderEnvelopeDTO } from 'support/types';
import { isMessageV2DTO } from 'support/helpers/transactions/transactions';
import { DocumentProperties } from 'components/Sidebar/SidebarProperties/SidebarProperties';
import { RelatedMessages } from 'components/WebEDI/WebEDISidebar/components/RelatedMessages/RelatedMessages';
import { useTranslation } from 'react-i18next';
import { TradePartnerNameAndLogo } from 'components/TradePartnerNameAndLogo';
import { InvoiceVerificationStatusBadge } from 'pages/InvoiceVerification/components/InvoiceVerificationStatusBadge/InvoiceVerificationStatusBadge';
import { formatDayAndTime } from 'support/helpers/dateTime/dateTime';
import { EMPTY_FIELD } from 'support/helpers/const/const';

type DocumentType = MessageV2DTO | SenderEnvelopeDTO;

type InvoiceVerificationDetailsSidebarProps = {
  document: DocumentType | undefined;
  relatedTransactions: Array<DocumentType> | undefined;
  currentPartner: PartnerDTO | undefined;
  invoiceVerificationDetails: InvoiceVerificationDTO;
};

export const InvoiceVerificationDetailsSidebar = ({
  document,
  invoiceVerificationDetails,
  currentPartner,
  relatedTransactions,
}: InvoiceVerificationDetailsSidebarProps) => {
  const { t } = useTranslation();
  const isMessage = document && isMessageV2DTO(document);
  const senderPartner = isMessage ? document.sender_partner : undefined;
  const receiverPartner = isMessage ? document.receiver_partner : null;
  const otherPartner = currentPartner && senderPartner?.id === currentPartner?.id ? receiverPartner : senderPartner;

  const properties = [
    {
      label: t('webedi:sidebar.properties.partner'),
      key: 'partner',
      value: (
        <TradePartnerNameAndLogo
          partner={otherPartner}
          size="small"
          textConfiguration={{ className: 'text-inherit' }}
          logoConfiguration={{ className: 'rounded-full' }}
        />
      ),
    },
    {
      label: t('invoiceVerification:sidebar.properties.status'),
      key: 'status',
      value: <InvoiceVerificationStatusBadge status={invoiceVerificationDetails.status} />,
    },
    {
      label: t('webedi:sidebar.properties.documentDate'),
      key: 'document-date',
      value: isMessage ? formatDayAndTime(document.created_at) : EMPTY_FIELD,
    },
  ];
  return (
    <Sidebar>
      <DocumentProperties properties={properties} />
      <RelatedMessages
        activeMessageId={undefined}
        currentPartner={currentPartner}
        relatedMessages={relatedTransactions}
      />
    </Sidebar>
  );
};
